const ctx = require.context('./assets/icons', true, /\.(svg)$/);
ctx.keys().forEach((key) => {
  ctx(key);
});